<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="批量生成"
    width="70%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form
        :model="batchGenerateData"
        :rules="batchGenerateRules"
        ref="batchGenerateRef"
        label-width="100px"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="前缀" prop="prefix">
              <el-input v-model="batchGenerateData.prefix" placeholder="请输入前缀"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="起数" prop="startNum">
              <el-input
                type="number"
                min="1"
                v-model="batchGenerateData.startNum"
                placeholder="请输入起数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="止数" prop="endNum">
              <el-input
                type="number"
                min="1"
                v-model="batchGenerateData.endNum"
                placeholder="请输入止数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="存放品种" prop="storageVariety">
              <el-select
                v-model="batchGenerateData.storageVariety"
                placeholder="请选择存放品种"
                style="width: 100%"
                multiple
              >
                <el-option
                  v-for="(item, index) of storageVariety"
                  :value="item.value"
                  :label="item.label"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { batchGenerateRules } from './rules';
  import { storageVariety } from '@/constants';
  export default {
    name: 'BatchGenerateDialog',
    data() {
      return {
        dialogVisible: false,
        batchGenerateRules,
        storageVariety,
        batchGenerateData: {
          prefix: '',
          startNum: '',
          endNum: '',
          storageVariety: '',
        },
      };
    },
    methods: {
      openModal(storageName) {
        this.dialogVisible = true;
        this.batchGenerateData = {
          ...this.batchGenerateData,
          prefix: storageName,
        };
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.$refs.batchGenerateRef.resetFields(); // 重置表单
      },
      confirmHandler() {
        this.$refs.batchGenerateRef.validate((valid) => {
          if (valid) {
            console.log(this.batchGenerateData, '提交数据');
            this.$emit('storeDataInfo', this.batchGenerateData);
            // this.cancelHandler();
            this.dialogVisible = false;
          } else {
            this.$message.error('请检查再提交');
          }
        });
      },
    },
  };
</script>

<style></style>
